import { combineReducers } from "redux";

import { userAdminDetails } from "./reducer.userAdmin"
const userAdminDetailsReducers = combineReducers({

    userAdminDetails

})
export default userAdminDetailsReducers;
